export const provider_links = {
	dnp: 'https://www.disneyplus.com/',
	nfx: 'https://www.netflix.com/',
	amp: 'https://www.primevideo.com/',
	hlu: 'https://www.hulu.com/',
	pmp: 'https://www.paramountplus.com/',
	atp: 'https://www.apple.com/apple-tv-plus/',
	pcp: 'https://www.peacocktv.com/',
	//dpu: 'https://www.discoveryplus.com/',
	yot: 'https://tv.youtube.com/welcome/',
	fuv: 'https://www.fubo.tv/',
	cru: 'https://www.crunchyroll.com/',
	koc: 'https://www.kocowa.com/',
	epx: 'https://www.mgmplus.com/',
	stz: 'https://www.starz.com/',
	sho: 'https://www.showtime.com/',
	acp: 'https://www.amcplus.com/',
	fmn: 'https://www.funimation.com/',
	mxx: 'https://www.max.com/',
	pcf: 'https://www.popcornflix.com/',
	tbv: 'https://www.tubi.tv/',
	aim: 'https://www.amazon.com/gp/video/splash/freevee_findus/',
	crk: 'https://www.crackle.com/',
};

export type ProvidersShortNames = keyof typeof provider_links;
